import { observer } from 'mobx-react';
import { FC } from 'react';
import { cashbackStore } from '../../store/cashbackStore';
import { LOCALES } from 'src/constants/main';
import { localeStore } from 'src/mobx/localesStore';
import MultiLanguageTextArea from 'src/view/components/Controls/MultiLanguageTextArea/MultiLanguageTextArea';
import { TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import './style.scss';

const CashbackDescription: FC = observer((): JSX.Element => {
  const handleDescriptionChange = (value: string, lang: LOCALES) => {
    cashbackStore.changeCashback({
      description: {
        ...cashbackStore.cashback.description,
        [lang]: value,
      },
    });

    if (!value) return;

    if (cashbackStore.validationErrors.descriptionEn || cashbackStore.validationErrors.descriptionAr) {
      cashbackStore.validateDescription();
    }
  };

  return (
    <MultiLanguageTextArea
      title={localeStore.t('offer_description')}
      enText={cashbackStore.cashback.description?.en}
      arText={cashbackStore.cashback.description?.ar}
      onChangeValue={handleDescriptionChange}
      required
      placeholder={localeStore.t('offer_description_placeholder')}
      titleTooltip={{ message: 'cashback_description_hint', position: TOOLTIP_POSITION.PORTAL }}
      validation={{
        enValid: cashbackStore.validationErrors.descriptionEn === null,
        enErrorText: cashbackStore.validationErrors.descriptionEn || '',
        arValid: cashbackStore.validationErrors.descriptionAr === null,
        arErrorText: cashbackStore.validationErrors.descriptionAr || '',
      }}
      className="cashback__description-area"
      textAreaClassName="family-medium letter-spacing-5"
    />
  );
});

export default CashbackDescription;
